import Icon from '@/app/utils/Icon'
import classNames from 'classnames'

type Props = {
    className?: string
    text?: string
}

export default function LoadingIcon(props: Props) {

    const { className, text } = props

    return (
        <div
            className={classNames('text-center flex flex-col gap-2 items-center', className)}
            style={{ filter: 'drop-shadow(0 0 0.25rem rgba(255, 255, 255, 1))' }}
        >
            <Icon.flower className="!w-6 animate-spin" />
            { text &&
                <div
                    className="text-[1rem] text-main font-bold text-shadow-main"
                    style={{ textShadow: '0 0 0.25rem rgba(255, 255, 255, 0.75)' }}
                >{text}</div>
            }
        </div>
    )
}